<div class="ng-scrollbar-container" [class.ng-scrollbar-autohide]="autoHide">

  <div #barX class="ng-scrollbar -horizontal {{barClass}}" [class.ng-scrollbar-disabled]="!trackX">
    <div #thumbX class="ng-scrollbar-thumb {{thumbClass}}"></div>
  </div>

  <div #barY class="ng-scrollbar -vertical {{barClass}}" [class.ng-scrollbar-disabled]="!trackY">
    <div #thumbY class="ng-scrollbar-thumb {{thumbClass}}"></div>
  </div>

  <div #view class="ng-scrollbar-view {{viewClass}}">
    <ng-content></ng-content>
  </div>
</div>
